import { doc, getDoc } from 'firebase/firestore';
import _ from 'lodash';
import { createRefPath } from '../appData/appRefPaths';

export const getAppProfileData = async (props, callback) => {

  const {
    appDataDocuments,
    appUserCollections,
    aps_viewItems,
    database_fns,
    callback_send,
    mainDb,
    np,
    pathViews,
  } = props

  const _callback = callback ? callback : props.callback
  const _viewItemKeys = aps_viewItems ? Object.keys(aps_viewItems) : {}
  const allowAttendeeProfiles = pathViews.clients ? true : false

  // get the profiles collection (admin)
  const ref_profile = createRefPath(['profiles'])
  const profiles = await database_fns.get_data({ refPath: ref_profile })

  const attendeeClientProfiles = allowAttendeeProfiles ? await getAttendeeClientProfiles(mainDb, pathViews, appUserCollections, appDataDocuments) : {}

  const collections = {
    profiles,
    attendeeClientProfiles
  }

  const appProfileData = getProfileGroups(appUserCollections, collections, _viewItemKeys, appDataDocuments)

  _callback && _callback(appProfileData)

  if (callback_send && np) {
    np.appProfileData = appProfileData
    callback_send(np)
  }

}

const getAttendeeClientProfiles = async (mainDb, pathViews, appUserCollections, appDataDocuments) => {
  if (appUserCollections) {
    const allEmails = _.chain(appUserCollections)
      .map(auc => appDataDocuments?.[auc])
      .filter()
      .flatMap(attendees => _.values(attendees))
      .map(a => _.toLower(_.trim(a?.email)))
      .filter()
      .uniq()
      .value();

    const acps = await getClientProfilesOnly(mainDb, pathViews.clients, allEmails);
    return acps
  }
}

/**
 * Get the client profiles of all of the attendees by email
 * @param {*} mainDb 
 * @param {*} clientKey 
 * @param {*} attendeeEmails 
 * @returns 
 */
const getClientProfilesOnly = async (mainDb, clientKey, attendeeEmails) => {
  const promises = attendeeEmails.map(email =>
    getDoc(doc(mainDb, `clients/${clientKey}/profiles/${email}`))
  );

  const snaps = await Promise.all(promises);

  return snaps.reduce((acc, snap) => {
    if (snap.exists()) {
      acc[snap.id] = { id: snap.id, ...snap.data() };
    }
    return acc;
  }, {});
};

const getProfileGroups = (appUserCollections, collections, _viewItemKeys, appDataDocuments) => {

  const { attendeeClientProfiles, profiles } = collections

  const _adminProfiles = profiles ? ammendProfilesInfo(profiles) : null
  const _allAppUsers = {}

  if (appUserCollections) {

    appUserCollections.forEach(appUserCollection => {

      const _appUsers = {}
      let appUsers;

      if (appDataDocuments?.[appUserCollection]) {
        appUsers = appDataDocuments[appUserCollection]
      } else if (collections[appUserCollection]) {
        appUsers = collections[appUserCollection]
      }

      // loop the targetData 
      if (appUsers) {
        _.forEach(appUsers, (appUser, key) => {
          ammendAppUsers(_appUsers, appUser, key, attendeeClientProfiles)
        })
      }
      _allAppUsers[appUserCollection] = _appUsers
    })
  }

  const profileInfo = {}
  if (_adminProfiles) { profileInfo.adminProfiles = _adminProfiles }
  if (attendeeClientProfiles) { profileInfo.attendeeClientProfiles = attendeeClientProfiles }

  return { ..._allAppUsers, ...profileInfo }

}

const ammendProfilesInfo = (profiles) => {
  const _profiles = {}
  if (profiles) {
    _.forEach(profiles, (profile, profileKey) => {
      _profiles[profileKey] = {
        lastName: profile.lastName,
        firstName: profile.firstName,
        email: profile.email,
        fcmTokens: profile.fcmTokens,
        initials: profile.initials,
        displayName: profile.displayName,
        pageFavs: profile.pageFavs,
        _itemKey: profileKey,
      }
    })
  }
  return _profiles
}

/**
 * Updates the _appUsers object with the data from the attendeeClientProfiles object
 * @param {object} _appUsers 
 * @param {object} appUser 
 * @param {string} key 
 * @param {object} attendeeClientProfiles 
 */
const ammendAppUsers = (_appUsers, appUser, key, attendeeClientProfiles) => {

  _appUsers[key] = { key: key }

  const { firstName, lastName, email, phoneNumber } = appUser

  _appUsers[key].lastName = lastName
  _appUsers[key].firstName = firstName
  _appUsers[key].email = email
  _appUsers[key].phoneNumber = phoneNumber
  _appUsers[key]._itemKey = key

  const cp = _.find(attendeeClientProfiles, { email: email })

  if (cp) {
    if (cp.fcmTokens) { _appUsers[key].fcmTokens = cp.fcmTokens }
    if (cp.initials) { _appUsers[key].initials = cp.initials }
    if (cp.displayName) { _appUsers[key].displayName = cp.displayName }
    if (cp.events) { _appUsers[key].events = cp.events }
    if (!cp.lastName && lastName) { cp.lastName = lastName }
    if (!cp.firstName && firstName) { cp.firstName = firstName }
  }

}